var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 169.803,
    viewBox: "0 0 200 169.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2980",
    "data-name": "Rectangle 2980",
    width: 200,
    height: 169.803,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22458",
    "data-name": "Group 22458",
    transform: "translate(-1349 -362.229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2981",
    "data-name": "Rectangle 2981",
    width: 172,
    height: 123,
    rx: 7,
    transform: "translate(1362 385)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    cx: 19.5,
    cy: 20,
    rx: 19.5,
    ry: 20,
    transform: "translate(1476 364)",
    fill: "#dd2228",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22454",
    "data-name": "Group 22454",
    transform: "translate(1349 362.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22453",
    "data-name": "Group 22453",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22201",
    "data-name": "Path 22201",
    d: "M138.354,50.195H48.52a16.258,16.258,0,0,0-16.229,16.25v58.895a2.083,2.083,0,1,0,4.167,0v-58.9A12.086,12.086,0,0,1,48.52,54.361h89.833a2.083,2.083,0,1,0,0-4.166",
    transform: "translate(-19.624 -30.505)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22202",
    "data-name": "Path 22202",
    d: "M32.291,291.96a2.083,2.083,0,1,0,4.167,0V285a2.083,2.083,0,1,0-4.167,0Z",
    transform: "translate(-19.624 -171.939)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22203",
    "data-name": "Path 22203",
    d: "M221.223,87.3a21.763,21.763,0,1,0,21.75,21.751A21.788,21.788,0,0,0,221.223,87.3m.06,24.947h-.161a5.864,5.864,0,1,1,.161,0m-.081,4.175a8.871,8.871,0,0,1,8.808,7.829,17.6,17.6,0,0,1-17.589.007,8.879,8.879,0,0,1,8.781-7.836m12.455,5.015a13.158,13.158,0,0,0-5.979-7.445A10.017,10.017,0,1,0,214.75,114a13.225,13.225,0,0,0-5.959,7.486,17.607,17.607,0,1,1,24.867-.049Z",
    transform: "translate(-121.21 -53.054)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22204",
    "data-name": "Path 22204",
    d: "M130.438,219.437a9.259,9.259,0,0,0,9.249,9.249h79.169a9.249,9.249,0,0,0,0-18.5H139.687A9.259,9.259,0,0,0,130.438,219.437Zm93.5,0a5.088,5.088,0,0,1-5.082,5.082H139.687a5.082,5.082,0,0,1,0-10.164h79.169A5.088,5.088,0,0,1,223.938,219.437Z",
    transform: "translate(-79.271 -127.738)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22205",
    "data-name": "Path 22205",
    d: "M228.1,278.522a9.259,9.259,0,0,0-9.249-9.249H139.687a9.249,9.249,0,1,0,0,18.5h79.169A9.259,9.259,0,0,0,228.1,278.522Zm-93.5,0a5.088,5.088,0,0,1,5.082-5.082h79.169a5.082,5.082,0,1,1,0,10.164H139.687A5.088,5.088,0,0,1,134.6,278.522Z",
    transform: "translate(-79.271 -163.646)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22206",
    "data-name": "Path 22206",
    d: "M223.036,330.375a2.083,2.083,0,0,0,0,4.167h22.487a2.083,2.083,0,1,0,0-4.167Z",
    transform: "translate(-134.28 -200.779)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22207",
    "data-name": "Path 22207",
    d: "M197.916,175.423H187.333V67.214a16.2,16.2,0,0,0-12.054-15.682,2.082,2.082,0,1,0-1.058,4.028,12.034,12.034,0,0,1,8.946,11.654V175.421H16.833V159.672a2.083,2.083,0,1,0-4.167,0v15.751H2.083A2.083,2.083,0,0,0,0,177.506v13a10.588,10.588,0,0,0,10.575,10.575H189.424A10.588,10.588,0,0,0,200,190.5v-13A2.083,2.083,0,0,0,197.916,175.423Zm-2.083,15.08a6.416,6.416,0,0,1-6.409,6.409H10.575A6.416,6.416,0,0,1,4.166,190.5V179.59H195.833Z",
    transform: "translate(0 -31.275)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22208",
    "data-name": "Path 22208",
    d: "M362.144,21.775a21.776,21.776,0,1,0-21.776,21.777,21.8,21.8,0,0,0,21.776-21.777m-39.386,0a17.61,17.61,0,1,1,17.61,17.61,17.63,17.63,0,0,1-17.61-17.61",
    transform: "translate(-193.618)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22209",
    "data-name": "Path 22209",
    d: "M368.891,39.223a2.082,2.082,0,0,0-2.946,0l-7.62,7.619-2.032-2.035a2.084,2.084,0,0,0-2.948,2.946l3.505,3.508a2.084,2.084,0,0,0,2.947,0l9.093-9.092A2.081,2.081,0,0,0,368.891,39.223Z",
    transform: "translate(-214.368 -23.466)",
    fill: "#212121"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksImg1);
export default __webpack_public_path__ + "static/media/how-it-works-img-1.030fbd328a15290a136edd374b082d85.svg";
export { ForwardRef as ReactComponent };